import { render } from "./AddInventairePage.vue?vue&type=template&id=59040c7a&ts=true"
import script from "./AddInventairePage.vue?vue&type=script&lang=ts"
export * from "./AddInventairePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__